import { useEffect, useState } from "react";
import { APIHandlerSimulation } from "hooks/api-handler-simulation";
export function UseApiCallSimulation({
  url,
  method,
  paramsData,
  skip = false,
  isM2CBackendUrl = false,
}: any) {
  const [data, setData] = useState<any>();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<any>();

  useEffect(() => {
    if (!skip) {
      getData();
    }
  }, [skip]);

  async function getData() {
    try {
      setIsLoading(true);
      const data: any = await APIHandlerSimulation({
        method,
        url,
        data: paramsData,
        isM2CBackendUrl,
      });

      setData(data);
    } catch (error) {
      setError(error);
    } finally {
      setIsLoading(false);
    }
  }
  function reset() {
    setData(undefined);
    setError(undefined);
    setIsLoading(false);
  }
  function refetch() {
    getData();
  }

  return { data, isLoading, error, refetch, reset };
}
